import { AsyncPipe } from "@angular/common";
import { Component, input, OnInit, output } from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { CustomValidations, getStrongPasswordValidator } from "blu-utilities";
import { Observable } from "rxjs";
import { BaseComponent } from "src/app/components/base/base.component";
import { ButtonComponent } from "src/app/components/button/button.component";
import { InputComponent } from "src/app/components/inputs/input/input.component";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { ErrorMessages, ErrorResponse } from "src/app/core/models/error";
import { LABELS } from "src/app/core/models/strings";
import { AppNotificationService } from "src/app/core/services/app-notification.service";
import { HasFormGroup } from "src/models/component";
import { ChangePasswordRequest } from "../../admins/models/admin";
import { AdminApiService } from "../../admins/services/admin-api.service";
import { AccountService } from "../services/account.service";

@Component({
  selector: "app-edit-password",
  templateUrl: "./edit-password.component.html",
  styleUrl: "./edit-password.component.scss",
  imports: [
    AddClassModifierDirective,
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    ButtonComponent,
    AsyncPipe,
  ],
})
export class EditPasswordComponent
  extends BaseComponent
  implements OnInit, HasFormGroup
{
  readonly passwordChanged = output<boolean>();
  readonly hasDarkBackground = input(false);
  submitFormLabel: Observable<string> = this.getLoadingLabel(
    "Save Password",
    LABELS.SAVING,
  );
  constructor(
    appNotificationService: AppNotificationService,
    private adminApiService: AdminApiService,
    private formBuilder: UntypedFormBuilder,
    private accountService: AccountService,
  ) {
    super(appNotificationService);
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.formGroupItem = this.formBuilder.group(
      {
        oldPassword: ["", [Validators.required]],
        password: ["", [Validators.required, getStrongPasswordValidator(12)]],
        confirmPassword: ["", [Validators.required]],
      },
      {
        validators: CustomValidations.MatchPasswords,
      },
    );
  }

  clearForm(): void {
    this.formGroupItem?.reset();
  }

  changePassword() {
    if (!this.isFormGroupValid()) {
      this.showError(ErrorMessages.FILL_REQUIRED_FIELDS);
      this.formGroupItem?.markAllAsTouched();
      return;
    }
    if (this.getIsFormLoading()) {
      return;
    }
    this.setIsFormBeingSubmitted(true);
    this.adminApiService.changePassword(this.buildRequest()).subscribe({
      next: (token) => {
        if (token) {
          this.accountService.setUserAccessToken(token);
        }
        this.setIsFormBeingSubmitted(false);
        this.showSuccess("Password changed successfully");
        this.passwordChanged.emit(true);
      },
      error: (error: ErrorResponse) => {
        this.handleErrorResponse(error);
        this.setIsFormBeingSubmitted(false);
      },
    });
  }

  buildRequest(): ChangePasswordRequest {
    return {
      old_password: this.formGroupItem?.get("oldPassword")?.value,
      new_password: this.formGroupItem?.get("password")?.value,
    };
  }
}
